import React, { ReactElement, useState, ReactType } from 'react';
import { Route, RouteComponentProps } from 'react-router-dom';
import { AuthHeader } from '../layout/AuthHeader';
import { Login } from './Login';
import { Col, Row } from 'antd';
import { SignUp } from './SignUp';
import { EmailLogin } from './EmailLogin';
import { ForgotPassword } from './ForgotPassword';
import { AccountType } from '../../store/auth/types';
import { DropdownSelect } from '../layout/GlobalTranslation';
import { ConfirmPasswordReset } from './ConfirmPasswordReset';

export interface AuthenticationRouteProps extends RouteComponentProps {
  setHeaderTitle?: React.Dispatch<React.SetStateAction<string>>;
}

export interface AuthenticationParams {
  accountType?: AccountType;
}

export const AuthenticationRouteComponent = (
  Component: ReactType,
  componentProps: AuthenticationRouteProps
) => (props: RouteComponentProps) => (
  <Component {...props} {...componentProps} />
);

export const Authentication: React.FC<RouteComponentProps> = (
  props
): ReactElement => {
  const [headerTitle, setHeaderTitle] = useState<string>('');
  const { match } = props;
  const authRouteProps: AuthenticationRouteProps = { setHeaderTitle, ...props };

  return (
    <Row className="authentication-screen">
      <Col span={24} className="authentication-header-container">
        <AuthHeader headerTitle={headerTitle} />
      </Col>
      <div className="welcome-translation">
        <DropdownSelect />
      </div>
      <Col span={24}>
        <Route
          path={`${match.url}/login/index/:accountType`}
          render={AuthenticationRouteComponent(Login, authRouteProps)}
        />
        <Route
          path={`${match.url}/login/email/:accountType`}
          render={AuthenticationRouteComponent(EmailLogin, authRouteProps)}
        />
        <Route
          path={`${match.url}/registration/:accountType`}
          render={AuthenticationRouteComponent(SignUp, authRouteProps)}
        />
        <Route
          path={`${match.url}/forgotPassword/:accountType`}
          render={AuthenticationRouteComponent(ForgotPassword, authRouteProps)}
        />
        <Route
          path={`${match.url}/reset-password/`}
          render={AuthenticationRouteComponent(
            ConfirmPasswordReset,
            authRouteProps
          )}
        />
      </Col>
    </Row>
  );
};
